import { GlobalStyles } from "./styles/globalStyles";

export default function ThemeStyles() {
  return <GlobalStyles />;
}
